import { Link, useSearchParams } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

const SEC = ({ title, children }) => (
  <div className="space-y-2">
    <h2 className="font-semibold text-lg">{title}</h2>
    <div className="text-sm text-slate-600 space-y-2 leading-relaxed">{children}</div>
  </div>
);

export default function Legal() {
  const [params] = useSearchParams();
  const aba = params.get("aba") || "termos";

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="sticky top-0 z-50 bg-slate-900/95 backdrop-blur-md text-white border-b border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center">
          <Link to="/"><Logo light /></Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="legal-page">
        <h1 className="text-3xl font-extrabold tracking-tight">Documentos legais</h1>
        <p className="mt-2 text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-lg p-3">
          Estes documentos são modelos-base e devem passar por revisão jurídica antes da operação comercial.
        </p>

        <Tabs defaultValue={aba} className="mt-8">
          <TabsList className="w-full justify-start overflow-x-auto">
            <TabsTrigger value="termos" data-testid="legal-termos">Termos de Uso</TabsTrigger>
            <TabsTrigger value="privacidade" data-testid="legal-privacidade">Privacidade</TabsTrigger>
            <TabsTrigger value="contribuicao" data-testid="legal-contribuicao">Contribuição de Dados</TabsTrigger>
            <TabsTrigger value="diretorio" data-testid="legal-diretorio">Diretório</TabsTrigger>
          </TabsList>

          <TabsContent value="termos" className="mt-6 space-y-6">
            <SEC title="1. O serviço">
              <p>O GEPR é uma plataforma de gestão para profissionais de refrigeração: calculadora de preços, orçamentos, ordens de serviço, CRM e referências regionais de mercado.</p>
            </SEC>
            <SEC title="2. Responsabilidades">
              <p>Os preços, orçamentos e serviços gerados são de responsabilidade exclusiva do usuário profissional. O GEPR é uma ferramenta de apoio e não garante resultados financeiros.</p>
              <p>As referências regionais são estatísticas agregadas e informativas — não constituem tabela de preços, recomendação de valor nem forma de coordenação entre concorrentes.</p>
            </SEC>
            <SEC title="3. Planos e pagamento">
              <p>Os planos pagos são cobrados por assinatura mensal ou anual, sem fidelidade. O cancelamento interrompe cobranças futuras e retorna a conta ao plano Grátis.</p>
            </SEC>
            <SEC title="4. Conduta">
              <p>É proibido inserir dados falsos na base colaborativa, tentar identificar outros profissionais ou usar a plataforma para combinar preços entre concorrentes.</p>
            </SEC>
          </TabsContent>

          <TabsContent value="privacidade" className="mt-6 space-y-6">
            <SEC title="1. Dados coletados">
              <p>Dados de cadastro (nome, e-mail, telefone), dados da empresa, clientes, equipamentos, orçamentos e contribuições de preços voluntárias.</p>
            </SEC>
            <SEC title="2. Uso dos dados">
              <p>Os dados são usados exclusivamente para operar o serviço. Contribuições de preço são anonimizadas e agregadas estatisticamente — nenhum valor individual, profissional ou empresa é identificável.</p>
            </SEC>
            <SEC title="3. Seus direitos (LGPD)">
              <p>Você pode acessar, corrigir, exportar e excluir seus dados, e revogar consentimentos a qualquer momento. A exclusão de contribuições próprias recalcula as estatísticas agregadas, sem efeito retroativo sobre estatísticas já publicadas.</p>
            </SEC>
            <SEC title="4. Segurança">
              <p>Autenticação criptografada, isolamento de dados por usuário e trilhas de auditoria administrativa.</p>
            </SEC>
          </TabsContent>

          <TabsContent value="contribuicao" className="mt-6 space-y-6">
            <SEC title="1. Natureza voluntária">
              <p>Contribuir com a base colaborativa de preços é opcional e nunca condição para usar a plataforma.</p>
            </SEC>
            <SEC title="2. O que você informa">
              <p>Cidade, estado, tipo de serviço, capacidade, valor praticado e data de referência. Nunca coletamos nome do seu cliente nem dados que identifiquem você publicamente.</p>
            </SEC>
            <SEC title="3. Como usamos">
              <p>Seus valores são agregados com os de outros profissionais (mediana, média aparada, faixas) e só são exibidos quando há quantidade mínima de contribuições, para preservar sua privacidade.</p>
            </SEC>
            <SEC title="4. O que é proibido">
              <p>Usar a base para combinar preços com concorrentes, inserir valores falsos ou tentar manipular as estatísticas. Valores suspeitos são sinalizados para revisão administrativa.</p>
            </SEC>
            <SEC title="5. Exclusão">
              <p>Você pode corrigir ou excluir suas contribuições a qualquer momento em Minhas contribuições.</p>
            </SEC>
          </TabsContent>

          <TabsContent value="diretorio" className="mt-6 space-y-6">
            <SEC title="1. Papel do GEPR">
              <p>O diretório apenas facilita a descoberta e o contato entre clientes e profissionais. O GEPR não garante qualidade, disponibilidade, preço ou execução do serviço.</p>
            </SEC>
            <SEC title="2. Responsabilidade">
              <p>Contrato, orçamento, pagamento, garantia e execução são de responsabilidade exclusiva entre cliente e profissional.</p>
            </SEC>
            <SEC title="3. Controle do profissional">
              <p>O perfil é opcional, pode ser ativado, editado ou desativado a qualquer momento, e nunca exibe endereço residencial ou dados sensíveis sem autorização.</p>
            </SEC>
            <SEC title="4. Moderação">
              <p>Perfis podem ser denunciados, suspensos ou removidos. Clientes autorizam o compartilhamento dos próprios dados de contato ao enviar uma solicitação (consentimento LGPD).</p>
            </SEC>
          </TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
